import React from 'react';
import { Box } from '@mui/material';
import CeoReportingDashboard from './CeoReportingDashboard';
import Dashboard from './Dashboard';

/**
 * Single modular dashboard: CEO/Salesforce widgets + BDM operational widgets.
 * Visibility per widget is controlled by role permissions (User Management).
 * Date range comes from the global selectors in the sidebar header.
 */
export default function UnifiedDashboard() {
  return (
    <Box>
      <CeoReportingDashboard unified />
      <Dashboard />
    </Box>
  );
}
